/**
 * Created by mark on 11/12/2017.
 */



import React from 'react';
import { Row, Col, Card } from 'react-bootstrap'
import ApplicationServices from '../services/base-service.js';
export default class Authentication extends React.Component {
    constructor(props) {
        super();
        this.props = props;
        this.state = {
            finishedCheck:false
        };
    }

    componentWillMount() {
        ApplicationServices.call("usercontroller/isUKUser", {apiVersion:7}).then(function(response){
            if (response.isUK == true) {
                this.setState({finishedCheck:true});
            } else {
                var country = response.actualCountry;
                switch (country) {
                    case "NETHERLANDS":
                        window.location.hash = '#/inschrijven';
                        break;
                    case "SWEDEN":
                        this.setState({finishedCheck:true});
                        return;
                    case "NEW ZEALAND":
                        window.location.hash = '#/signupnewzealand';
                        break;
                    case "AUSTRALIA":
                        window.location.hash = '#/signupaustralia';
                        break;
                    case "IRELAND":
                        window.location.hash = '#/signupaustralia';
                        break;
                    default:
                        window.location.hash = '#/signupglobal';
                        break;

                }
            }
        }.bind(this))
    }

    authentication() {
    }

    render() {
        if (!this.state.finishedCheck) {
            return "";
        }
        return <div>
            <Row>
                <Col>
                    <br />
                    <br />
                    <Card body>
                        <br />
                        <center style={{ top: '-50px', marginLeft: '-75px', left: '50%', position: 'absolute' }}><img height="150px" src="./img/logos/languagenut/no-text-logo.png" /></center>
                        <br />
                        <br />
                        <center><h1 class="display-4" style={{ marginBottom: '10px' }}>Thank You!<br /><small><small></small></small></h1></center>
                        <br />
                        <p>Thank you for signing up for Languagenut. To get your school access to the resources we need a short call with you to set up Languagenut to align to your curriculum. Please email me on <a href="mailto:archie@languagenut.com">archie@languagenut.com</a> or <a href="https://www.languagenut.com/global/book-a-demo/?no_redirect=true">click here</a> here to schedule a meeting.</p>

                        <b>Key Features</b>
                        <br />

                        <ul class="fa-ul">
                            <li><span class="fa-li"><i class="fas fa-check"></i></span><b>Primary/Elementary, Secondary/High and EAL/ESOL</b> resources.</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>8,000 exam-style questions - reading, writing, listening and speaking</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Pre-made assignments - <b>over 300 hours of tasks ready for home learning</b></li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Resources in <b>French, Spanish, German, Mandarin + 20</b> more languages</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>2,500+ vocabulary items</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Comprehensive grammar and verb activities</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Sentence building games</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Create your own content</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Set assignment/homework</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Comprehensive reporting, tracking and feedback for your students</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Practise forming full sentences and sentence chunks</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Improve your pronunciation with our engaging phonics activities</li>
                        </ul>

                        <hr />
                        <p>
                            <center>
                                <span style={{ fontStyle: 'italic' }}>"Languagenut is the most complete digital language resource that combines the features of Linguascope, Vocab Express and Pearson Active Learn plus a whole lot more under one platform. Languagenut offers better content, more flexibility and engages our students.

                                    The ability to assign work to students and the Exam Revision area are great features they save us hours of time every week. The platform allows me to give written and verbal feedback to my students and is the only resource with spontaneous speech practice as homework which has been a revelation"</span>
                                <br />
                                <br />
                                <b>The British School Al Khubairat</b>
                            </center>
                        </p>
                        <center>
                            <small>For any questions email <a href="mailto:archie@languagenut.com">archie@languagenut.com</a></small>
                            <br /><img height="80px" src="https://s3-eu-west-1.amazonaws.com/marketing.languagenut.com/Sales%20site/Languagenut%20Sales%20Sites%20Image%20Assets/LN%20Logo.png" />
                        </center>
                    </Card>
                </Col>
            </Row>
        </div>
    }
}